// src/pages/Cloud/components/CloudScopeSelector.js
import React from 'react';
import { Input } from 'reactstrap';
import { Form, Spinner } from 'react-bootstrap';

import { CLOUD_SCOPE_ALL, CLOUD_SCOPE_ALL_LABEL } from '../cloudScopeConfig';

/**
 * 平台無關的雲端查詢範圍下拉（Azure subscription / GCP project / AWS account）。
 * 純呈現元件：資料與選取狀態由外部提供。
 */
export default function CloudScopeSelector({
  label = 'Subscription',
  value,
  options = [],
  onChange,
  loading = false,
  disabled = false,
  includeAll = true,
  allValue = CLOUD_SCOPE_ALL,
  allLabel = CLOUD_SCOPE_ALL_LABEL,
}) {
  const handleChange = (event) => {
    if (onChange) {
      onChange(event.target.value);
    }
  };

  return (
    <Form.Group>
      <Form.Label>
        <span style={{ fontWeight: 'bold' }}>{label}</span>
        {loading && <Spinner animation="border" size="sm" className="ms-2" />}
      </Form.Label>

      <Input
        type="select"
        bsSize="sm"
        value={value || allValue}
        onChange={handleChange}
        disabled={disabled || loading}
      >
        {includeAll && <option value={allValue}>{allLabel}</option>}

        {options.map((option) => (
          <option key={option.id} value={option.id}>
            {option.name || option.id}
          </option>
        ))}
      </Input>
    </Form.Group>
  );
}
